"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EmailTemplates", {
  enumerable: true,
  get: function () {
    return _EmailTemplates.EmailTemplates;
  }
});
var _EmailTemplates = require("./EmailTemplates");